<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Editar Cliente IKAcesso</h5>
                <hr>                
                <FormCliente ref="formCliente"/>                 
                <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="fechar"/>
                <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>
            </div>
        </div>
    </div>
</template>

<script>

import FormCliente from '@/components/pages/cadastro/cliente-ikacesso/FormCliente.vue';
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService.js';
import { exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    clienteService: null,
    props: ['id'],
    data() {
        return {           
            pacotes: [],            
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        salvar() {
            let cliente = this.$refs.formCliente.getDados();
            if(!cliente) {
                return;
            }   
            this.clienteService.alterar(cliente)
            .then(resp => {		
				if(resp.data.status == 200) {
                    exibirMensagemSis(this, resp.data.entity.mensagem, false);
                    setTimeout(() => {
						this.fechar();
					}, 1000);
                } else {
                    exibirMensagemSis(this, resp.data.entity.mensagem, true);
                }
            }).catch(erro => {              
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            });
        },  
        buscar() {
            if(this.id) {
                this.clienteService.buscar(this.id)
                .then(resp => {		
                    let cliente = resp.data.entity;
                    this.$refs.formCliente.setCliente(cliente);
                }).catch(erro => {              
                    if(erro.response && erro.response.data.status == 401) {
                        exibirMensagemSis(this, erro.response.data.message, true);
                    } else {
                        exibirMensagemSis(this, 'Erro interno do servidor', true);
                        console.log(erro.request)
                    } 
                });
            }
        },
        fechar() {
            this.$router.push('/cadastro/clientes/ikacesso');
        },       
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();    
        this.buscar();
    },
    components: {
        FormCliente
    }
}
</script>

<style>

</style>